import Vue from 'vue'
import VueRouter, { Location as VueLocation } from 'vue-router'
import SearchPage from '@/views/SearchPage.vue'
import AllResults from '@/views/AllResults.vue'
import CategoryResults from '@/views/CategoryResults.vue'

Vue.use(VueRouter)

const routes = [
  {
    name: 'main',
    path: '/search',
    component: SearchPage,
    children: [
      {
        name: 'results',
        path: ':searchPhrase',
        component: AllResults
      },
      {
        // при совпадении пути с шаблоном /search/:searchPhrase/:categoryId
        // в <router-view> компонента searchPage будет показан searchPageCategory
        name: 'results-category',
        path: ':searchPhrase/:categoryId',
        component: CategoryResults
      }
    ]
  }
  // {name: 'results-category', path: '/search/:searchPhrase/:categoryId', component: searchPage},
]

class RouterProvider {
  private router?: VueRouter

  public getRouter (): VueRouter {
    if (!this.router) {
      this.router = new VueRouter({
        routes: routes,
        mode: 'hash'
      })

      this.router.beforeEach((to, from, next) => {
        next() // продолжаем стандартное поведение

        // если кириллица в урле, то делаем энкод
        // такое случается при навигации по истории браузера вперед/назад
        if (to.fullPath.match(/.*[А-Яа-я].*/gi) !== null && this.router) {
          this.router.replace(encodeURI(to.fullPath))
        }
      })
    }

    return this.router
  }
}

const routerProvider = new RouterProvider()

export default routerProvider
